import React, { useState } from 'react';
import { toast } from 'sonner';
import { FileDown, Loader2, Share2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { buildProvisionalPdf, downloadFile } from '../utils/provisionalPdf';

const shareText = (race) =>
  `Resultados provisorios · ${race?.speedhive_session_name || race?.name || ''} (DATAPRO)`;

export const PdfShareActions = ({ race, isBestLap, getRows }) => {
  const [busy, setBusy] = useState(null);

  const build = () => buildProvisionalPdf({ race, rows: getRows(), isBestLap });

  const handleDownload = async () => {
    setBusy('pdf');
    try {
      downloadFile(await build());
    } catch {
      toast.error('No se pudo generar el PDF');
    } finally {
      setBusy(null);
    }
  };

  const handleWhatsApp = async () => {
    setBusy('wa');
    try {
      const file = await build();
      const text = shareText(race);
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        try {
          await navigator.share({ files: [file], title: file.name, text });
          return;
        } catch (e) {
          if (e?.name === 'AbortError') return;
        }
      }
      downloadFile(file);
      window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener');
      toast.success('PDF descargado: adjuntalo en el chat de WhatsApp que se abrió');
    } catch {
      toast.error('No se pudo compartir el PDF');
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="flex flex-wrap gap-2 pt-3">
      <Button
        onClick={handleDownload}
        disabled={!!busy}
        variant="outline"
        size="sm"
        className="border-neutral-700 text-gray-200 hover:bg-neutral-800"
        data-testid="prov-download-pdf-btn"
      >
        {busy === 'pdf' ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <FileDown className="w-4 h-4 mr-1.5" />}
        Descargar PDF
      </Button>
      <Button
        onClick={handleWhatsApp}
        disabled={!!busy}
        size="sm"
        className="bg-green-600 hover:bg-green-700 text-white"
        data-testid="prov-share-whatsapp-btn"
      >
        {busy === 'wa' ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <Share2 className="w-4 h-4 mr-1.5" />}
        Compartir por WhatsApp
      </Button>
    </div>
  );
};

export default PdfShareActions;
